export enum UserProfileQueryKeys {
  Report = "userProfileReport",
}
